/**
 * shadcn sidebar-07 shell (all viewports; sheet on small screens). **On by default.**
 *
 * Opt out: `REACT_APP_USE_SHADCN_SIDEBAR=false` or `localStorage.setItem('useShadcnSidebar', 'false')`.
 * Opt in explicitly (redundant if already default): `REACT_APP_USE_SHADCN_SIDEBAR=true` or `localStorage.setItem('useShadcnSidebar', 'true')`.
 */
export function isShadcnSidebarEnabled(): boolean {
  if (process.env.REACT_APP_USE_SHADCN_SIDEBAR === "false") {
    return false;
  }
  if (process.env.REACT_APP_USE_SHADCN_SIDEBAR === "true") {
    return true;
  }
  if (typeof window !== "undefined") {
    const v = localStorage.getItem("useShadcnSidebar");
    if (v === "false") return false;
    if (v === "true") return true;
  }
  return true;
}
